import { Injectable } from '@angular/core';


import {Observable, of, throwError} from 'rxjs';
import {QuestionBase} from "../models/question-base";
import {DropdownQuestion} from "../models/question-dropdown";
import {TextboxQuestion} from "../models/question-textbox";
import {catchError, map, shareReplay} from "rxjs/operators";
import {withoutGlobalSpinner} from "../../../theme/utils/spinner-context";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {TextAreaQuestion} from "../models/question-textarea";
import {SelectBigBox} from "../models/select-big-box";
import {MultiSelectBox} from "../models/multi-select-box";
import {ImagesBox} from "../models/images-box";
import {PersonContact} from "../models/person-contact";
import {SelectRelatedDescription} from "../models/select-related-description";
import {CheckboxQuestion} from "../models/checkbox-question";

@Injectable()
export class QuestionService {

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }
  constructor(private http: HttpClient, private apiKey: ApiUrl) {
  }
  // TODO: get from a remote source of question metadata
  private handleObserverError(error: any): Observable<any>{
    return throwError(error.error || error)
  }
  dataProccessing(questionList:any){
    const questions: QuestionBase<string>[] = [];
    questionList.forEach((question:any)=>{
        if(question.controlType === 'SelectField') {
          questions.push(
            new DropdownQuestion({
            key: question.key,
            label: question.label,
            page: question.page,
            type:question.type,
            disabled: question.disabled,
            section: {
              ...question.section,
              description: question.section.description,
              namespace: question.section.namespace,
              number: question.section.number,
              sectionKey:question.section.sectionKey,
              expanded: question.section.expanded,
              callBackFunction: question.section.callBackFunction
            },
            options: [],
            required: question.required,
            callBackFunction : question.callBackFunction,
            relatedField: question.relatedField,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam,
            value: question.value
          })
        )
      }
      if(question.controlType === 'ImagesBox') {
        questions.push(
          new ImagesBox({
            key: question.key,
            label: question.label,
            page: question.page,
              value: question.value,
              disabled: question.disabled,
            section: {
              ...question.section,
              description: question.section.description,
              namespace: question.section.namespace,
              number: question.section.number,
              sectionKey:question.section.sectionKey,
              expanded: question.section.expanded,
              callBackFunction: question.section.callBackFunction
            },
            options: [],
            callBackFunction : question.callBackFunction,
            relatedField: question.relatedField,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam

          }),
        )
      }
      if(question.controlType === 'PersonContact') {
        questions.push(
          new PersonContact({
            key: question.key,
            label: question.label,
            page: question.page,
            section: {
              ...question.section,
              description: question.section.description,
              namespace: question.section.namespace,
              number: question.section.number,
              sectionKey: question.section.sectionKey,
              expanded: question.section.expanded,
              callBackFunction: question.section.callBackFunction
            },
            options: [],
              value: question.value,
              disabled: question.disabled,
            callBackFunction : question.callBackFunction,
            relatedField: question.relatedField,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam
          }),
        )
      }
      if(question.controlType === 'MultiSelectBox') {

        questions.push(
          new MultiSelectBox({
            key: question.key,
            label: question.label,
            page: question.page,
            section: {
              ...question.section,
              description: question.section.description,
              namespace: question.section.namespace,
              number: question.section.number,
              expanded: question.section.expanded,
              sectionKey: question.section.sectionKey,
              callBackFunction: question.section.callBackFunction
            },
            options: [],
            callBackFunction : question.callBackFunction,
            relatedField: question.relatedField,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
              value: question.value,
              disabled: question.disabled,
            additionalParam: question.additionalParam
          }),
        )
      }
      if(question.controlType === 'SelectBigBox') {
        questions.push(
          new SelectBigBox({
            key: question.key,
            label: question.label,
            page: question.page,
            section: {
              ...question.section,
              description: question.section.description,
              namespace: question.section.namespace,
              number: question.section.number,
              sectionKey: question.section.sectionKey,
              expanded: question.section.expanded,
              callBackFunction: question.section.callBackFunction
            },
            options: [],
            callBackFunction : question.callBackFunction,
            relatedField: question.relatedField,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            value: question.value,
              disabled: question.disabled,
            additionalParam: question.additionalParam
          }),
        )
      }
      if(question.controlType === 'SelectRelatedDescription') {
        questions.push(
          new SelectRelatedDescription({
            key: question.key,
            label: question.label,
            page: question.page,
            section: question.section,
            value: question.value =="None" ?undefined : question.value,
              disabled: question.disabled,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam
          })
        )
      }
      if(question.controlType === 'Text') {
        questions.push(
          new TextboxQuestion({
            key: question.key,
            label: question.label,
            page: question.page,
            // Pass the schema's `type` through (e.g. 'date') so fields like nadlan's
            // Entrance render a real native date-picker <input type="date"> instead of
            // always falling back to a plain text box (SCRUM-67).
            type: question.type,
            section: question.section,
            value: question.value =="None"?'' : question.value,
              disabled: question.disabled,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam
          }),
        )
      }
      if(question.controlType === 'CheckBox') {
        questions.push(
          new CheckboxQuestion({
            key: question.key,
            type: 'checkbox',
            label: question.label,
            page: question.page,
            section: question.section,
            value: question.value =="None"?'' : question.value,
              disabled: question.disabled,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam
          }),
        )
      }
      if(question.controlType === 'TextArea') {
        questions.push(
          new TextAreaQuestion({
            key: question.key,
            label: question.label,
            page: question.page,
            value: question.value =="None"?'' : question.value,
              disabled: question.disabled,
            section: question.section,
            required: question.required,
            order: question.order,
            addClass: question.addClass,
            additionalParam: question.additionalParam
          }),
        )
      }
    });
    // SCRUM-154: carry "required unless <checkbox>" onto every control type.
    const sourceByKey = new Map<string, any>(questionList.map((question: any) => [question.key, question]));
    questions.forEach(question => {
      const source = sourceByKey.get(question.key);
      question.requiredUnless = source?.requiredUnless || '';
      // SCRUM-155: field hint + character limit
      question.hint = source?.hint || '';
      question.maxLength = source?.maxLength || null;
      question.inputFormat = source?.inputFormat || '';
    });
    return of(questions.sort((a, b) => a.order - b.order));
  }
  // SCRUM-147: the dynamic-form schema for a namespace (all sections/questions,
  // e.g. the full "car" or "nadlan" form) rarely changes within a session, but
  // it used to be re-fetched from the server on every single call site --
  // including every time a user opened an ad's detail dialog in "My Ads".
  // That extra network round-trip is what made "טוען פרטי מודעה..." linger.
  // Cache the in-flight/completed request per namespace so repeat calls
  // (re-opening ads of the same category, switching between them, etc.)
  // resolve instantly instead of hitting the server again.
  // SCRUM-154: the selected sub-category can overload the form, so it is part
  // of the cache key (namespace + subCategoryId).
  private questionsCache = new Map<string, Observable<any>>();

  fetchQuestions(selectedNamespace: string, subCategoryId: string | number | null = null): Observable<QuestionBase<string>>{
    const cacheKey = `${selectedNamespace}::${subCategoryId ?? ''}`;
    const cached = this.questionsCache.get(cacheKey);
    if (cached) {
      return cached;
    }
    // SCRUM-147: callers show their own loader ("טוען פרטי מודעה..."), so the
    // global full-page spinner is skipped for this request.
    const request$ = this.http.get(this.apiKey.getFormsQuestion(selectedNamespace, subCategoryId),
      {...this.options, context: withoutGlobalSpinner()})
      .pipe(
        map((res) => res ? this.dataProccessing(res) : null),
        catchError((error) => {
          // Don't cache failed requests - let the next attempt retry the server.
          this.questionsCache.delete(cacheKey);
          return this.handleObserverError(error);
        }),
        shareReplay({bufferSize: 1, refCount: false})
      );
    this.questionsCache.set(cacheKey, request$);
    return request$;
  }
  // SCRUM-154: subCategoryId lets the selected sub-category overload the form
  // (e.g. motorcycle / scooter on top of the CAR form).
  getServerQuestions(namespace: string, subCategoryId: string | number | null = null): Observable<any>{
    return this.fetchQuestions(namespace, subCategoryId);
  }
  // getServerQuestions(namespace: string):Observable<QuestionBase<any>[]>{
  //
  //     return this.fetchQuestions(namespace).subscribe(questionList => {
  //       let generatedArr:any = [];
  //       questionList.forEach((question:any)=>{
  //         if(question.type === 'select') {
  //           generatedArr.push(
  //             new DropdownQuestion({
  //             key: 'brave',
  //             label: 'Bravery Rating',
  //             options: [
  //               {key: 'solid', value: 'Solid'},
  //               {key: 'great', value: 'Great'},
  //               {key: 'good', value: 'Good'},
  //               {key: 'unproven', value: 'Unproven'}
  //             ],
  //             order: 3
  //           })
  //           )
  //         }
  //
  //       });
  //
  //     })
  // }

  getQuestions() {

    const questions: QuestionBase<string>[] = [

      new DropdownQuestion({
        key: 'brave',
        label: 'Bravery Rating',
        options: [],
        order: 3
      }),

      new TextboxQuestion({
        key: 'firstName',
        label: 'First name',
        value: 'Bombasto',
        required: true,
        order: 1
      }),

      new TextboxQuestion({
        key: 'emailAddress',
        label: 'Email',
        type: 'email',
        order: 2
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
